function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { useCallback, useEffect, useMemo, useState } from "react";
import PictureComponent from "components/core/picture/picture-component";
import ClickableTagsGrid from "segments/desktop/core-components/clickable-tags-grid/clickable-tags-grid";
import AssetComponent from "components/core/asset/asset-component";
import { trackEvent } from "services/bigbrain-service";
import { TAGS_DEFAULT_ASSET_CLICKED } from "constants/bigbrain-event-types";
import { StyledTagsAndAssetsComponent } from "./tags-and-assets-component.scss";
const TagsAndAssetsComponent = ({ tagsTitle, tags, defaultImage, onClustersChange, enabledDefaultImageAnimation, flipUseCasesAndAssets, renderCta, useCasesTopMargin, imageMaxWidth, assetsAndTagsExtraSpace, startAtCenter, blurDefaultImage, tagsTitleAlignment, preSelectedTag })=>{
    const initialWasInteracted = Boolean(preSelectedTag);
    const [wasInteracted, setWasInteracted] = useState(initialWasInteracted);
    const [latestSelectedTab, setLatestSelectedTab] = useState(preSelectedTag !== null && preSelectedTag !== void 0 ? preSelectedTag : null);
    const [didDefaultClicked, setDidDefaultClicked] = useState(false);
    const [hoverTag, setHoverTag] = useState(null);
    const [shouldSetMoveToPositionAnimation, setShouldSetMoveToPositionAnimation] = useState(false);
    const isCentralized = startAtCenter && !wasInteracted;
    const tagAssets = useMemo(()=>tags === null || tags === void 0 ? void 0 : tags.map(({ tagImage })=>tagImage), [
        tags
    ]);
    const onTagSelectionChange = useCallback((selectedTags)=>{
        !wasInteracted && setWasInteracted(true);
        setLatestSelectedTab(selectedTags[selectedTags.length - 1] || null);
        onClustersChange(selectedTags);
    }, []);
    useEffect(()=>{
        if (startAtCenter && wasInteracted) {
            setShouldSetMoveToPositionAnimation(true);
        }
    }, [
        startAtCenter,
        wasInteracted
    ]);
    const onAssetClick = ()=>{
        if (latestSelectedTab) return;
        setDidDefaultClicked(true);
        trackEvent(TAGS_DEFAULT_ASSET_CLICKED);
    };
    const handleAnimationEnd = (event)=>{
        if (event.animationName === "moveToPositionFromCenter") {
            setShouldSetMoveToPositionAnimation(false);
        }
        if (event.animationName === "breathe") {
            setDidDefaultClicked(false);
        }
    };
    const handleTagHover = (tag)=>{
        setHoverTag(tag);
    };
    const selectedTagToShow = hoverTag || latestSelectedTab;
    return /*#__PURE__*/ _jsxs(StyledTagsAndAssetsComponent, {
        onAnimationEnd: handleAnimationEnd,
        className: classnames("tags-and-assets-component", {
            centered: isCentralized,
            "movement-animation": shouldSetMoveToPositionAnimation
        }),
        flipUseCasesAndAssets: flipUseCasesAndAssets,
        isCentralized: isCentralized,
        useCasesTopMargin: useCasesTopMargin,
        imageMaxWidth: imageMaxWidth,
        blurDefaultImage: blurDefaultImage,
        assetsAndTagsExtraSpace: assetsAndTagsExtraSpace,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: classnames("use-cases-container", {
                    breathe: enabledDefaultImageAnimation && didDefaultClicked
                }),
                children: /*#__PURE__*/ _jsx(ClickableTagsGrid, {
                    tagsTitleAlignment: tagsTitleAlignment,
                    onTagSelectionChange: onTagSelectionChange,
                    tags: tags,
                    renderCta: renderCta,
                    tagsTitle: tagsTitle,
                    handleTagHover: handleTagHover,
                    preSelectedTag: preSelectedTag
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "assets-container",
                onClick: onAssetClick,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("default-asset", {
                            active: !latestSelectedTab
                        }),
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread({
                            hideControls: true
                        }, defaultImage))
                    }),
                    tagAssets === null || tagAssets === void 0 ? void 0 : tagAssets.map((tagAsset, index)=>/*#__PURE__*/ _jsx("div", {
                            className: classnames("picture-wrapper", {
                                selected: selectedTagToShow === tags[index]
                            }),
                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                src: (tagAsset === null || tagAsset === void 0 ? void 0 : tagAsset.src) || (defaultImage === null || defaultImage === void 0 ? void 0 : defaultImage.src)
                            }, index)
                        }))
                ]
            })
        ]
    });
};
export default TagsAndAssetsComponent;
